import { FC, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../../../../images/EVENT TO BEE-17.png";
interface RecuDownloaderProps {
  reservation: any;
}

const RecuDownloader: FC<RecuDownloaderProps> = ({ reservation }) => {
  const [isLoading, setIsLoading] = useState(false);

  const downloadFacture = () => {
    setIsLoading(true);

    const doc = new jsPDF();
    autoTable(doc, {});

    // Colors defined as tuples
    const primaryColor: [number, number, number] = [70, 99, 172]; // #4663AC
    const textColor: [number, number, number] = [50, 50, 50];
    const white: [number, number, number] = [255, 255, 255];

    // Fonts
    doc.setFont("helvetica", "bold");

    // Header
    doc.setFillColor(...white);
    doc.rect(0, 0, 210, 40, "F");
    doc.setTextColor(...textColor);
    doc.setFontSize(22);
    doc.text("REÇU", 195, 20, { align: "right" });
    // Logo (Placeholder - replace with actual image path)
    const logoUrl = logo; // Fallback
    try {
      doc.addImage(logoUrl, "PNG", 10, 1, 40, 40);
    } catch (e) {
      console.warn("Logo image could not be loaded:", e);
    }

    // Client and Receipt Details
    doc.setTextColor(...textColor);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Client:", 15, 50);
    doc.text("Reçu:", 165, 50);
    doc.setFont("helvetica", "bold");
    doc.text(`${reservation.Client?.name || "N/A"} ${reservation.Client?.lastName || ""}`.toUpperCase(), 15, 58);
    doc.setFont("helvetica", "normal");
    doc.text(reservation.invoice_code || "N/A", 176, 50);
    doc.setFont("helvetica", "bold");
    doc.text("Date:", 165, 57);
    doc.setFont("helvetica", "normal");
    doc.text(reservation.selectedDate ? new Date(reservation.selectedDate).toLocaleDateString() : "N/A", 175, 57);

    // Horizontal Line
    doc.setDrawColor(...primaryColor);
    doc.setLineWidth(0.5);
    doc.line(15, 80, 195, 80);

    // Reservation Details
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text(reservation.Location?.title || "N/A", 15, 90);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(
      `Adresse du logement: ${reservation.Location?.city || "N/A"} , ${reservation.Location?.address || "N/A"}`,
      15,
      98
    );
    doc.text(
      `Date: ${reservation.selectedDate ? new Date(reservation.selectedDate).toLocaleDateString() : "N/A"}`,
      15,
      106
    );
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(`Horaires: ${reservation.startHour || "N/A"} - ${reservation.endHour || "N/A"}`, 15, 114);

    // Horizontal Line
    doc.line(15, 120, 195, 120);

    // Price Details
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text("Détail du prix", 15, 130);

    // Line Items Table
    const lineItems = reservation.lineItems?.data || [];
    const tableData = lineItems.map((item: any, index: number) => {
      const description =
        item.description === reservation.Location?.title
          ? `${(item.price.unit_amount / 100).toFixed(2)} x ${item.quantity} `
          : item.description === "Frais de service" || item.description === "Frais de ménage"
            ? item.description
            : `${item.description} ${item?.price?.unit_amount === 0 ? `(Gratuit x ${item.quantity})` : `(${(item.price.unit_amount / 100).toFixed(2)} x ${item.quantity})`}`;
      return [description, `${(item.amount_subtotal / 100).toFixed(2)} €`];
    });
    let totalAmount = 0;
    // Discount Row
    const discountAmount = reservation.discount || 0;
    if (discountAmount > 0) {
      tableData.push(["Montant de réduction", `- ${discountAmount} €`]);
    }

    // Total Row
    totalAmount = lineItems.reduce((sum: number, item: any) => sum + item.amount_subtotal, 0) - discountAmount;
    tableData.push(["Total (EUR)", `${(reservation.session.amount_total / 100).toFixed(2)} €`]);

    autoTable(doc, {
      startY: 135,
      head: [["Description", "Montant"]],
      body: tableData,
      theme: "grid",
      headStyles: {
        fillColor: primaryColor,
        textColor: white,
        fontSize: 10,
      },
      styles: {
        fontSize: 9,
        cellPadding: 4,
        textColor: textColor,
      },
      columnStyles: {
        0: { halign: "left" },
        1: { halign: "right" },
      },
    });

    // Payment Information
    const tableY = (doc as any).lastAutoTable?.finalY || 160;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text("Informations sur le paiement", 15, tableY + 10);
    const paymentData = [
      [
        `Paiement (${reservation.card_details?.card?.brand || "N/A"} xxxxxxxxxxxx ${
          reservation.card_details?.card?.last4 || "N/A"
        })`,
        `${(totalAmount / 100).toFixed(2)} €`,
      ],
    ];
    autoTable(doc, {
      startY: tableY + 15,
      body: paymentData,
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 4,
        textColor: textColor,
      },
      columnStyles: {
        0: { halign: "left" },
        1: { halign: "right" },
      },
    });

    // Footer
    const footerY = 270;
    doc.setFillColor(...primaryColor);
    doc.rect(0, footerY, 210, 30, "F");
    doc.setFontSize(8);
    doc.setTextColor(...white);
    doc.setFont("helvetica", "normal");
    doc.text("EVENTTOBEE, 7 rue de l’industrie 92400 Courbevoie", 20, footerY + 10);
    // doc.text("Consulter votre facture: " + "https://eventtobee.com", 20, footerY + 18);
    const linkText = "Consulter votre facture";
    doc.text(linkText, 20, footerY + 18);
    // Add clickable link without showing URL
    doc.link(20, footerY + 15, 60, 6, { url: "https://eventtobee.com/client/factures" });

    // Save PDF
    doc.save(`Recu_${reservation.reference}.pdf`);

    setIsLoading(false);
  };

  return (
    <ButtonPrimary
      loading={isLoading}
      onClick={downloadFacture}
      disabled={isLoading}
      className="transition-transform duration-300 transform sm:w-auto hover:scale-105 btn-primary-gradient"
    >
      <span>Télécharger</span>
    </ButtonPrimary>
  );
};

export default RecuDownloader;
